import PropTypes from "prop-types"
import { Component } from 'react'
import moment from 'moment'
import intl from 'react-intl-universal'
import Fetch from 'utils/fetch'
import SessionUser from 'utils/user-storage'
import StorePersist from 'utils/store-persist'
import { downloadFile, generateQueryParams } from 'utils/custom-functions'
import Header from 'components/header'
import Filter from './filter'
import Loading from 'components/center-loading'
import ImportExport from 'components/import-export'
import { IconFilterActive } from 'components/icons/icn-filter-active.icon'
import { IconFilterInactive } from 'components/icons/icn-filter-inactive.icon'
import Table from './components/table'
import SnackBar from 'material-ui/Snackbar'

import './composicao-carga.css'
import { isLoadCompositionFlowSupplierSide, isScheduleAgreementFlow, usesTmsIntegration } from 'utils/validations-general-settings'
import IconAddSmall from 'components/icons/icn-add-small-blue.icon'
import { normalizeDataInEnglish } from 'services/load-composition.service'
import { buscarComposicaoPorPedido } from './form/composicao-carga-form.service'
import ModalLoadComposition from 'components/modal-load-composition'
import ButtonIcon from "components/button-icon"
import IconUpload from "components/icons/icn-upload.icon"

const filtersDefault = {
  IdFornecedor: 0,
  IdUnidadeNegocio: 0,
  DataColetaDe: '',
  DataColetaAte: '',
  DataEntregaDe: '',
  DataEntregaAte: '',
  DeliveryTimeFrom: '',
  DeliveryTimeTo: '',
  Situacao: '',
  IdCarteira: '',
  IdFamiliaRotulada: '',
  SchedulingAgreement: '',
  PoNumber: [],
  LoadComposition:[],
}

class ComposicaoCarga extends Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        idPedido: PropTypes.any
      })
    }).isRequired
  }

  constructor() {
    super()
    this.state = {
      openForm: false,
      showFeedback: false,
      messageFeedBack: '',
      idComposicaoSelecionada: 0,
      composicoes: [],
      isFetching: false,
      idPedido: 0,
      modoLeitura: true,
      showFilterComposition: false,
      useFilterDefault: false,
      filters: filtersDefault,
      takeComposicoes: 50,
      page: 0,
      totalComposicoes: 0,
      openImportExport: false
    }
  }

  componentDidMount() {
    this.loadCompletePage();
  }

  async loadCompletePage () {
    const { idPedido } = this.props.match.params;
    const { filters } = this.state;
    const filterMyItensOnly = StorePersist.getValuesJSON('filterMyItemsOnly');
    const filtersComposition = StorePersist.getValuesJSON('filtersComposition');
    let _filters = filters;

    if (idPedido) {
      await this.openFormByTimeline(idPedido)
      const index = window.location.href.lastIndexOf('/')
      const url = window.location.href.substring(0, index)
      window.history.replaceState({}, {}, url)
    }

    if (filtersComposition) {
      _filters = filtersComposition;
    }

    this.setState({
      filters: _filters,
      useFilterDefault: filterMyItensOnly
    }, () => this.buscarComposicoes(0))
  }

  searchFilters = (filters) => {
    StorePersist.setValuesJSON('filtersComposition', filters);
    this.showFilterComposition()
    this.setState({
      filters: filters,
      composicoes: [],
    }, () => this.buscarComposicoes(0))
  }

  getFilterIcon = () => {
    if (localStorage.getItem("THEME") != 1)
      if (Object.values(this.state.filters).some(x => x))
        return <IconFilterActive />;
      else
        return <IconFilterInactive />;
    else
      return undefined
  }

  showFilterComposition = () => {
    this.setState(prevState => ({
      showFilterComposition: !prevState.showFilterComposition,
    }))
  }

  buscarComposicoes = (page = 0) => {
    this.startFetching()

    this.setState({
      page,
    }, () => {
      const model = {
        SupplierId: this.state.filters.IdFornecedor && this.state.filters.IdFornecedor >= 0 ? this.state.filters.IdFornecedor : null,
        BusinessUnitId: this.state.filters.IdUnidadeNegocio && this.state.filters.IdUnidadeNegocio >= 0 ? this.state.filters.IdUnidadeNegocio : null,
        DateCollectFrom: this.state.filters.DataColetaDe,
        DateCollectTo: this.state.filters.DataColetaAte,
        DeliveryDateFrom: this.state.filters.DataEntregaDe,
        DeliveryDateTo: this.state.filters.DataEntregaAte,
        DeliveryTimeMin: this.state.filters.DeliveryTimeFrom,
        DeliveryTimeMax: this.state.filters.DeliveryTimeTo,
        Situation: this.state.filters.Situacao,
        MaterialGroupId: this.state.filters.IdCarteira,
        LabeledFamilyId: this.state.filters.IdFamiliaRotulada,
        SchedulingAgreement: this.state.filters.SchedulingAgreement && isScheduleAgreementFlow() ? this.state.filters.SchedulingAgreement : null,
        PoNumber: this.state.filters.PoNumber,
        LoadComposition: this.state.filters.LoadComposition,
        UseFilterDefault: this.state.useFilterDefault,
        Take: this.state.takeComposicoes,
        Page: page
      }

      Fetch.get(`/load-compositions:cards-paginated?${generateQueryParams(model)}`)
        .then((response) => {
          this.setState({
            composicoes: response.data.Data,
            totalComposicoes: response.data.TotalRecordCount,
          })
          this.stopFetching()
        })
        .catch((e) => {
          this.stopFetching()
        })
    })
  }

  startFetching = () => {
    this.setState({
      isFetching: true
    })
  }

  stopFetching = () => {
    this.setState({
      isFetching: false
    })
  }

  closeFeedback = () => {
    this.setState({
      showFeedback: false
    })
  }

  openFormByTimeline = async (idPedido) => {
    this.setState({ idPedido });

    const _composition = await buscarComposicaoPorPedido(idPedido);
    this.openEditForm(normalizeDataInEnglish(_composition));
  }

  openEditForm = async (composicao) => {
    this.setState({
      idComposicaoSelecionada: composicao.LoadCompositionId,
      modoLeitura: composicao.ReadOnly,
      responsavelProximaAcao: composicao.ResponsavelProximaAcao,
      openForm: true
    })
  }

  openNewForm = () => {
    this.setState({ idPedido: 0, modoLeitura: false }, () => this.openForm())
  }

  openForm = () => {
    this.setState({
      openForm: true
    })
  }

  closeForm = () => {
    this.setState({
      openForm: false,
      idComposicaoSelecionada: 0
    }, () => this.buscarComposicoes(this.state.page))
  }

  refreshData = () => {
    this.buscarComposicoes(this.state.page)
    this.closeForm()
  }

  isProvider = () => SessionUser.get().TipoUsuario === 2

  openImportExport = () => {
    this.setState({
      openImportExport: true,
    })
  }

  closeImportExport = () => {
    this.setState({
      openImportExport: false,
    })
  }

  downloadArquivo = () => {
    Fetch.get(`pedidoVolume/exportar/PedidoVolume`)
      .then((response) => {
        const datafile = moment(new Date()).format('YYYYMMDD_HHmmss')
        downloadFile(`${datafile}_PedidoVolume.csv`, 'csv', response.data)
      })
      .catch((e) => this.proccessErro(e))
  }

  importationModelDownload = () => {
    Fetch.get(`pedidoVolume/download/DownloadModeloPedidoComposicaoCarga`)
      .then((response) => {
        const datafile = moment(new Date()).format('YYYYMMDD_HHmmss')
        downloadFile(`${datafile}_ModeloPedidoComposicaoCarga.csv`, 'csv', response.data)
      })
      .catch((e) => this.proccessErro(e))
  }

  redirectRoute = (_route) => {
    this.props.history.push(_route)
  }

  render() {
    let {
      openForm,
      showFeedback,
      messageFeedBack,
      composicoes,
      idComposicaoSelecionada,
      isFetching,
      idPedido,
      modoLeitura,
      showFilterComposition,
      filters,
      openImportExport
    } = this.state

    const user = SessionUser.get()

    return (
      <div className='container-composicao-carga'>
        <Loading isLoading={isFetching} />
        <Header title={intl.get('transports.compoCharge.header.title')} titleWidth={400}>
          <div className='buttons-header-container'>
            {isLoadCompositionFlowSupplierSide() &&
              <div title={intl.get('transports.compoCharge.actions.newComposition')}>
                <ButtonIcon
                  onClick={this.openNewForm}
                  buttonType='secondary'
                  buttonIcon={<IconAddSmall />}
                  className={'button-img-small-square'}
                />
              </div>
            }
            {user.TipoUsuario === 1 && usesTmsIntegration() &&
              <div title={intl.get('transports.compoCharge.actions.requestVolumn')}>
                <ButtonIcon
                  onClick={this.openImportExport}
                  buttonType='secondary'
                  buttonIcon={<IconUpload />}
                  className={'button-img-small-square'}
                  title={intl.get('exportImportModal.transportInformation.title')}
                />
              </div>
            }
            <div className='filterContainer'>
              <ButtonIcon
                onClick={this.showFilterComposition}
                buttonType='secondary'
                buttonText={intl.get('filters.filter')}
                buttonIcon={this.getFilterIcon()}
                className={'button-filter'}
              />
            </div>
          </div>
        </Header>

        <Filter
          showFilter={showFilterComposition}
          useFilterDefault={this.state.useFilterDefault}
          initialData={filters}
          handleClose={this.searchFilters}
          isProvider={this.isProvider()}
        />

        <Table
          data={composicoes}
          handleEdit={this.openEditForm}
          refreshSearch={this.buscarComposicoes}
          page={this.state.page}
          take={this.state.takeComposicoes}
          totalComposicoes={this.state.totalComposicoes}
        />

        {openForm &&
          <ModalLoadComposition
            open={openForm}
            compositionId={idComposicaoSelecionada}
            redirectRoute={this.redirectRoute}
            handleRefresh={this.refreshData}
            readingMode={modoLeitura}
            close={this.closeForm}
            idPedido={idPedido}
          />
        }

        <SnackBar
          onRequestClose={this.closeFeedback}
          open={showFeedback}
          message={messageFeedBack}
          autoHideDuration={3000}
        />

        <ImportExport
          title={intl.get('exportImportModal.transportInformation.title')}
          contextModal='transportInformation'
          open={openImportExport}
          handleClose={this.closeImportExport}
          downloadArquivo={this.downloadArquivo}
          downloadModelo={this.importationModelDownload}
          importArquivo='pedidoVolume/importar/PedidosPorPedidoVolume'
          type="CSV"
        />
      </div>
    )
  }
}

export default ComposicaoCarga
